<template>
  <div class="chart-wrapper">
    <apexchart height="256" type="donut" :options="chartOptions" :series="series" class="elsa-chart" />
  </div>
</template>

<script>
import { toPairs, compose, map, last, head, propOr, pickAll, defaultTo, pathOr } from 'ramda'
import { mapGetters } from 'vuex'
import { toFixed } from '../../../utils/ramda-utils'
import pickBy from 'ramda/src/pickBy'
const categories = ['lt_56_percent', '56_67_percent', '67_78_percent', '78_90_percent', 'mt_90_percent']

export default {
  props: {
    chartData: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      dataByCategories: {
        lt_56_percent: {
          tooltipTitle: this.$t('charts.elsa_score_range.beginner'),
          legend: this.$t('charts.elsa_score_range.beginner')
        },
        '56_67_percent': {
          tooltipTitle: this.$t('charts.elsa_score_range.lower_intermediate'),
          legend: this.$t('charts.elsa_score_range.lower_intermediate')
        },
        '67_78_percent': {
          tooltipTitle: this.$t('charts.elsa_score_range.intermediate'),
          legend: this.$t('charts.elsa_score_range.intermediate')
        },
        '78_90_percent': {
          tooltipTitle: this.$t('charts.elsa_score_range.advanced'),
          legend: this.$t('charts.elsa_score_range.advanced')
        },
        mt_90_percent: {
          tooltipTitle: this.$t('charts.elsa_score_range.native'),
          legend: this.$t('charts.elsa_score_range.native')
        }
      }
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          height: 262,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            dataLabels: {
              offset: 0
            },
            donut: {
              size: '30%',
              labels: {
                show: this.chartData && Object.keys(this.chartData).length === 0,
                total: {
                  show: this.chartData && Object.keys(this.chartData).length === 0,
                  label: this.$t('charts.total_learners'),
                  color: '#000',
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  }
                }
              }
            }
          }
        },
        colors: ['#4A12FF', '#567AFB', '#47A1F5', '#28CCE0', '#18EDB2'],
        labels: this.labels,
        dataLabels: {
          textAnchor: 'middle',
          style: {
            fontFamily: 'SF Pro Display, sans-serif'
          },
          formatter: function (val, opts) {
            return `${(Math.round(val * 100) / 100).toFixed(0)}%`
          },
          dropShadow: {
            enabled: false
          }
        },
        yaxis: {
          decimalsInFloat: 0
        },
        legend: {
          formatter: (seriesName, ops) => {
            // if (this.chartData && this.chartData[seriesName]) {
            //   return this.chartData[seriesName]["value"];
            // }
            // 
            // const numberOfStudents = pathOr(0, ["chartData", seriesName])(this);
            // const token = numberOfStudents === 1 ? "student" : "students";
            // const message = this.$t(
            //   this.$i18nLabelsHelper(this.currentOrganizationType, token)
            // );
            // const seriesTitle = this.$t(
            //   `classes.classes_details.activity_reports.${seriesName}`
            // );

            // // return `${seriesTitle}: ${numberOfStudents} ${message}`;

            return this.dataByCategories[seriesName].legend
          },
          itemMargin: {
            horizontal: 5,
            vertical: 5
          },

          fontFamily: 'SF Pro Display, sans-serif',
          fontSize: 16,
          fontWeight: 400,
          offsetY: 40,
          labels: {
            colors: '#121131'
          },
          horizontalAlign: 'center'
        },
        grid: {
          show: false,
          borderColor: undefined
        },
        stroke: {
          show: false
        },
        tooltip: {
          y: {
            formatter: (numberOfStudents) => {
              const token = numberOfStudents === 1 ? 'student' : 'students'

              const message = this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, token))

              return `${numberOfStudents} ${message}`
            },
            title: {
              formatter: (seriesName, ops) => {
                // return this.$t(
                //   `classes.classes_details.activity_reports.${seriesName}`
                // );

                return this.dataByCategories[seriesName].tooltipTitle
              }
            }
          }
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        // fill: {
        //   type: "gradient",
        //    gradient: {
        //     shade: 'light',
        //    }
        // },
        markers: {
          radius: '50%',
          width: 12,
          height: 12,
          customHTML: function () {
            return '<span class="custom-marker"><i class="fas fa-chart-pie"></i></span>'
          },
          offsetY: 8
        },
        noData: {
          text: this.$t('charts.no_data'),
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#000',
            fontSize: '14px',
            fontFamily: 'SF Pro Display, sans-serif'
          }
        }
      }
    },

    series: compose(
      map(compose(defaultTo(0), last)),
      toPairs,
      pickAll(categories),
      pickBy((val, key) => key),
      propOr({}, ['chartData'])
    ),
    labels: compose(
      map(head),
      toPairs,
      pickAll(categories),
      pickBy((val, key) => key),
      propOr({}, ['chartData'])
    ),
    ...mapGetters('organization', ['currentOrganizationType'])
  }
}
</script>

<style lang="scss" scoped>
.elsa-chart {
  margin-top: auto;
  margin-bottom: auto;
}

.chart-wrapper {
  height: 350px;
  display: flex;
  flex-direction: column;
}

.custom-marker {
  height: 12px;
  width: 12px;

  border-radius: 50%;
  display: inline-block;
}

.elsa-char::v-deep .apexcharts-legend-series {
  margin-bottom: 8px;
  line-height: 1.5;
}
</style>
